<template>
  <div class="news-list-panel">
    <el-card>
      <div slot="header" class="clearfix">
        <span>资讯查询</span>
      </div>
      <el-row :gutter="20">
        <el-col :span="5">
          <el-input v-model="query.title" placeholder="标题" clearable @keyup.enter.native="handleSearch" />
        </el-col>
        <el-col :span="4">
          <el-select v-model="query.typeId" placeholder="分类" clearable style="width: 100%;">
            <el-option v-for="item in typeOptions" :key="item.typeId" :label="item.typeName" :value="item.typeId" />
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select v-model="query.areaId" placeholder="归属社区" clearable style="width: 100%;">
            <el-option v-for="item in areaOptions" :key="item.areaId" :label="item.areaName" :value="item.areaId" />
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select v-model="query.state" placeholder="状态" clearable style="width: 100%;">
            <el-option v-for="item in stateOptions" :key="item.value" :label="item.name" :value="item.value" />
          </el-select>
        </el-col>
        <el-col :span="3">
          <el-button type="primary" @click="handleSearch">查询</el-button>
        </el-col>
      </el-row>
    </el-card>

    <el-card>
      <div slot="header" class="clearfix">
        <span>资讯列表</span>
        <el-button type="primary" size="small" style="float: right;" @click="goAdd">
          新增资讯
        </el-button>
      </div>
      <el-table v-loading="loading" :data="newsList" border style="width: 100%">
        <el-table-column prop="title" label="标题" align="center" show-overflow-tooltip min-width="160" />
        <el-table-column label="分类" align="center" width="110">
          <template slot-scope="scope">
            {{ typeNameOf(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column prop="areaName" label="归属社区" align="center" width="120" />
        <el-table-column label="封面" align="center" width="90">
          <template slot-scope="scope">
            <el-image v-if="scope.row.headerImg" :src="scope.row.headerImg" fit="cover"
              style="width: 60px; height: 60px;" :preview-src-list="[scope.row.headerImg]" />
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="readCount" label="阅读量" align="center" width="80" />
        <el-table-column prop="likeCount" label="点赞数" align="center" width="80" />
        <el-table-column label="置顶" align="center" width="80">
          <template slot-scope="scope">
            <el-tag v-if="isTopFlag(scope.row)" size="mini" type="danger">置顶</el-tag>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" align="center" width="100">
          <template slot-scope="scope">
            <el-tag size="mini" :style="getStateTagStyle(scope.row.state)">
              {{ getStateName(scope.row.state) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="publishTime" label="发布时间" align="center" width="150" :formatter="formatDateTime" />
        <el-table-column prop="createUserName" label="创建人" align="center" width="100" />
        <el-table-column label="操作" align="center" width="240" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" @click="goEdit(scope.row)">编辑</el-button>
            <el-button v-if="canPublish(scope.row)" size="mini" type="primary"
              @click="handlePublish(scope.row)">发布</el-button>
            <el-button v-if="canOff(scope.row)" size="mini" type="warning"
              @click="handleOff(scope.row)">下架</el-button>
            <el-button v-if="canDelete(scope.row)" size="mini" type="danger"
              @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination :current-page.sync="page.current" :page-sizes="[10, 20, 30, 50]" :page-size="page.size"
        :total="page.total" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" />
    </el-card>
  </div>
</template>

<script>
import {
  listAreaNews,
  listAreaNewsTypes,
  deleteAreaNews,
  publishAreaNews,
  offAreaNews
} from '@/api/community/areaNewsApi'
import { listAreas } from '@/api/community/areaApi'
import { dateFormat, timeFormat } from '@/utils/dateUtil'

export default {
  name: 'AreaNewsList',
  data() {
    return {
      loading: false,
      typeOptions: [],
      areaOptions: [],
      newsList: [],
      stateOptions: [
        { value: '1000', name: '草稿' },
        { value: '2000', name: '已发布' },
        { value: '3000', name: '已下架' }
      ],
      query: {
        title: '',
        typeId: '',
        areaId: '',
        state: ''
      },
      page: {
        current: 1,
        size: 10,
        total: 0
      }
    }
  },
  created() {
    this.loadTypes()
    this.loadAreas()
    this.loadData()
  },
  methods: {
    getStateName(state) {
      const names = {
        '1000': '草稿',
        '2000': '已发布',
        '3000': '已下架'
      }
      return names[String(state)] || '未知'
    },
    getStateTagStyle(state) {
      const styles = {
        '1000': { color: '#909399', backgroundColor: 'rgba(144, 147, 153, 0.1)', border: '1px solid rgba(144, 147, 153, 0.2)' },
        '2000': { color: '#4CAF50', backgroundColor: 'rgba(76, 175, 80, 0.1)', border: '1px solid rgba(76, 175, 80, 0.2)' },
        '3000': { color: '#FF9800', backgroundColor: 'rgba(255, 152, 0, 0.1)', border: '1px solid rgba(255, 152, 0, 0.2)' }
      }
      return styles[String(state)] || styles['1000']
    },
    isTopFlag(row) {
      return String(row.isTop) === '1'
    },
    canPublish(row) {
      const state = String(row.state)
      return state === '1000' || state === '3000'
    },
    canOff(row) {
      return String(row.state) === '2000'
    },
    canDelete(row) {
      const state = String(row.state)
      return state === '1000' || state === '3000'
    },
    typeNameOf(row) {
      const item = this.typeOptions.find(t => String(t.typeId) === String(row.typeId))
      return item ? item.typeName : (row.typeName || '-')
    },
    loadTypes() {
      listAreaNewsTypes({ page: 1, row: 500 }).then(res => {
        const data = res || {}
        this.typeOptions = data.types || []
      }).catch(() => {})
    },
    loadAreas() {
      listAreas({ page: 1, row: 500 }).then(res => {
        const data = (res && res.data) || {}
        this.areaOptions = data.areas || []
      }).catch(() => {})
    },
    loadData() {
      this.loading = true
      listAreaNews({
        page: this.page.current,
        row: this.page.size,
        title: this.query.title,
        typeId: this.query.typeId,
        areaId: this.query.areaId,
        state: this.query.state
      }).then(res => {
        const data = res || {}
        this.newsList = data.newsList || []
        this.page.total = data.total || 0
      }).catch(error => {
        this.$message.error(error.message || '获取资讯列表失败')
      }).finally(() => {
        this.loading = false
      })
    },
    handleSearch() {
      this.page.current = 1
      this.loadData()
    },
    goAdd() {
      this.$router.push('/views/community/addAreaNews')
    },
    goEdit(row) {
      this.$router.push(`/views/community/editAreaNews?newsId=${row.newsId}`)
    },
    formatDateTime(row, column, cellValue) {
      if (!cellValue) {
        return '-'
      }
      return dateFormat(cellValue) + ' ' + timeFormat(cellValue)
    },
    handlePublish(row) {
      this.$confirm('确定发布该资讯？发布后将对用户可见。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        publishAreaNews({ newsId: row.newsId }).then(() => {
          this.$message.success('发布成功')
          this.loadData()
        }).catch(error => {
          this.$message.error(error.message || '发布失败')
        })
      }).catch(() => {})
    },
    handleOff(row) {
      this.$confirm('确定下架该资讯？下架后用户不可见。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        offAreaNews({ newsId: row.newsId }).then(() => {
          this.$message.success('下架成功')
          this.loadData()
        }).catch(error => {
          this.$message.error(error.message || '下架失败')
        })
      }).catch(() => {})
    },
    handleDelete(row) {
      this.$confirm('确定删除该资讯？物理删除后不可恢复！', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteAreaNews({ newsId: row.newsId }).then(() => {
          this.$message.success('删除成功')
          this.loadData()
        }).catch(error => {
          this.$message.error(error.message || '删除失败')
        })
      }).catch(() => {})
    },
    handleSizeChange(val) {
      this.page.size = val
      this.page.current = 1
      this.loadData()
    },
    handleCurrentChange(val) {
      this.page.current = val
      this.loadData()
    }
  }
}
</script>

<style lang="scss" scoped>
.news-list-panel {
  padding: 20px;

  .el-card {
    margin-bottom: 20px;
  }

  .el-pagination {
    margin-top: 20px;
    text-align: right;
  }
}
</style>
